import React, { useState } from 'react';
import { offset, shift, useFloating } from '@floating-ui/react';
import { BlockSegmentsOnlyUsersFlag } from '../../constants/featureFlagConstants';
import { useClientTokenManager, useCurrentClientManager, useFeatureFlags, } from '../../context';
import { trackEvent } from '../../utils';
import { BlockedAccountLevelView } from '../BlockedAccountLevelView';
export const BLOCKED_ACCOUNT_LEVEL_LINK_WRAPPER_TEST_IDS = {
    wrapper: 'blocked-link-wrapper-test-id',
};
// TODO: This component is likely superceded by BlockedLinkWrapper, check if any other MFEs are using this before deleting
export const BlockedAccountLevelLinkWrapper = ({ children, hasRequiredAccountLevel, linkType, modalOffset = 0, path, requiredAccountLevels, notAvailableToSegmentsOnlyUser, }) => {
    const { selectedAccountLevel } = useCurrentClientManager();
    const { isSegmentsOnlyUser } = useClientTokenManager();
    const { getFeatureFlag } = useFeatureFlags();
    const blockSegmentsOnlyUsersEnabled = getFeatureFlag(BlockSegmentsOnlyUsersFlag);
    const [showBlockedModal, setShowBlockedModal] = useState(false);
    const openModal = () => {
        setShowBlockedModal(true);
    };
    const closeModal = () => {
        setShowBlockedModal(false);
    };
    const handleWrapperClick = (event) => {
        if (hasRequiredAccountLevel) {
            return;
        }
        trackEvent('Click - blocked segment-agnostic view - navigation link', {
            linkType,
            path,
            requiredAccountLevel: requiredAccountLevels?.[0],
            selectedAccountLevel,
        });
        event.preventDefault();
        event.stopPropagation();
        if (!showBlockedModal) {
            openModal();
        }
        else {
            closeModal();
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleWrapperClick(event);
        }
    };
    const { elements, floatingStyles, refs } = useFloating({
        middleware: [offset(modalOffset), shift()],
        placement: 'bottom',
    });
    const modalRefs = {
        modalElement: elements.floating,
        linkWrapperElement: elements.reference,
        setModalRef: refs.setFloating,
    };
    if (blockSegmentsOnlyUsersEnabled) {
        if (notAvailableToSegmentsOnlyUser && isSegmentsOnlyUser) {
            return null;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-testid": BLOCKED_ACCOUNT_LEVEL_LINK_WRAPPER_TEST_IDS.wrapper, onClickCapture: handleWrapperClick, onKeyDown: handleKeyDown, ref: refs.setReference, role: "button", tabIndex: 0 }, children),
        showBlockedModal && requiredAccountLevels && (React.createElement(BlockedAccountLevelView, { closeModal: closeModal, modalRefs: modalRefs, modalStyles: floatingStyles, path: path, requiredAccountLevels: requiredAccountLevels, variant: "modal" }))));
};
